import React, { Component } from "react";
import "./SearchFilterSlideIn.scss";
import FilterSection from "./FilterSection";

import equipmentIcon from "./assets/filter-equipment.svg";
import timesIcon from "./assets/filter-time.svg";
import conceptsIcon from "./assets/filter-concept.svg";
import brandsIcon from "./assets/filter-brand.svg";
import instructorsIcon from "./assets/filter-instructor.svg";
import musicIcon from "./assets/filter-music.svg";
import explicitIcon from "./assets/filter-language.svg";

import {
  createSearchQueryURL,
  toggler,
  getTags,
  fetchTags,
  fetchConcepts,
  fetchInstructors,
  saveFilterItemsToClientStorage,
  getFilterItemsFromClientStorage,
  saveChosenItemsToClientStorage,
  getChosenItemsFromClientStorage,
  getCachedTags
} from "./helpers";

class SearchFilterSlideIn extends Component {
  state = {
    equipment: [],
    times: [],
    concepts: [],
    brands: [],
    instructors: [],
    music: [],
    explicit: [],
    inputText: "",
    chosenEquipment: [],
    chosenTimes: [],
    chosenConcepts: [],
    chosenBrands: [],
    chosenInstructors: [],
    chosenMusic: [],
    ...getFilterItemsFromClientStorage(),
    ...getChosenItemsFromClientStorage()
  };

  componentDidMount() {
    const cachedTags = getCachedTags();
    if (cachedTags) return this.setState(cachedTags);
    fetchTags().then(tags => {
      const equipment = getTags(tags, "equipment"),
        times = getTags(tags, "classDuration"),
        brands = getTags(tags, "brand"),
        music = getTags(tags, "musicType");
      this.setState(
        {
          equipment,
          times,
          brands,
          music
        },
        () => {
          const { equipment, times, brands, music } = this.state;
          saveFilterItemsToClientStorage({ equipment, times, brands, music });
        }
      );
    });
    fetchConcepts().then(({ records }) =>
      this.setState({ concepts: records.map(r => r.gist) }, () => {
        const { concepts } = this.state;
        saveFilterItemsToClientStorage({ concepts });
      })
    );
    fetchInstructors().then(instructorData => {
      const instructors = instructorData.map(i => ({
        title: `${i.firstName} ${i.lastName}`
      }));
      this.setState({ instructors }, () => {
        const { instructors } = this.state;
        saveFilterItemsToClientStorage({ instructors });
      });
    });
  }
  handleSearch = () => {
    window.localStorage.setItem(
      "searchFilterURL",
      createSearchQueryURL(this.state)
    );
    window.location.href = "/filter";
  };
  handleInputChange = e => {
    const value = e.target.value;
    this.setState({ inputText: value });
  };
  toggleMaker = chosenArrayName => itemToToggle => e => {
    this.setState(
      prevState => {
        const chosenArray = prevState[chosenArrayName],
          toggledArray = toggler(chosenArray, itemToToggle),
          newToggledState = { [chosenArrayName]: toggledArray };
        return newToggledState;
      },
      () => {
        const latestChosenArray = this.state[chosenArrayName],
          latestToggledState = { [chosenArrayName]: latestChosenArray };
        saveChosenItemsToClientStorage(latestToggledState);
      }
    );
  };
  renderFilters = (itemsKey, label, image) => {
    const chosenItemsKey = `chosen${itemsKey[0].toUpperCase() +
        itemsKey.slice(1)}`,
      toggleItem = this.toggleMaker(chosenItemsKey),
      items = this.state[itemsKey],
      chosenItems = this.state[chosenItemsKey];
    return items.length !== 0 ? (
      <FilterSection {...{ items, toggleItem, chosenItems, label, image }} />
    ) : null;
  };
  renderLanguageFilter = () => {
    const items = [{ title: "FILTER OUT" }],
      toggleItem = this.toggleMaker("explicit"),
      chosenItems = this.state.explicit,
      label = "Explicit Language",
      image = explicitIcon;
    return (
      <FilterSection {...{ items, toggleItem, chosenItems, label, image }} />
    );
  };
  render() {
    const rf = this.renderFilters,
      { isOpen } = this.props;
    return (
      <div className={`search-slidein ${isOpen ? "" : "is-closed"}`}>
        <button
          className="search-slidein-close"
          onClick={this.props.toggleMenu}
        >
          close
        </button>
        <div className="search-slidein-searchbar">
          <span className="search-slidein-icon">
            <i className="ion-ios-search-strong" />
          </span>
          <input
            className="search-slidein-input"
            type="text"
            value={this.state.inputText}
            onChange={this.handleInputChange}
          />
        </div>
        <div className="tags-wrapper">
          {rf("equipment", "Equipment", equipmentIcon)}
          {rf("times", "Time", timesIcon)}
          {rf("concepts", "Class Type", conceptsIcon)}
          {rf("brands", "Brand", brandsIcon)}
          {rf("instructors", "Instructor", instructorsIcon)}
          {rf("music", "Music", musicIcon)}
          {this.renderLanguageFilter()}
        </div>
        <button className="search-slidein-button" onClick={this.handleSearch}>
          Apply
        </button>
      </div>
    );
  }
}

export default SearchFilterSlideIn;
